<template>
    <!-- 商品明细 -->
    <div class="shop_detail" >
        <div class="detail" v-if="length>1" @click="gospeed(data.returnId)" >
            <div class="image">
                <div v-for="(item,index) in data.orderItemList" :key="index">
                    <img :src="item.productPic"  />
                </div>
            </div>
        </div>
        <template v-else>
            <div class="detailTwo" v-for="(item,index) in data.orderItemList" :key="index" @click="gospeed(data.returnId)">
                <div class="imageTwo">
                    <img :src="item.productPic" />
                </div>
                <div class="rightTwo">
                    <div class="boxTwo">
                    <div class="text_1Two">
                        {{item.productName}}
                    </div>
                    <div class="text_2Two">{{item.productAttr}}</div>
                    </div>
                </div>
            </div>
        </template>
        <div class="rietagdilht"><van-icon name="arrow" /></div>
    </div>
</template>
<script>
import { Icon } from 'vant'
import { orderInfo } from '@/request/api'
export default {
  props: ['item'],
  components: {
    [Icon.name]: Icon
  },
  data() {
    return {
      data: {},
      length: ''
    }
  },
  methods: {
    gospeed(data) {
      console.log(data)
      this.$router.push({ path: '/Speed', query: { id: data, MultiCommodity: 2 } })
    }
  },
  created() {
    console.log(this.item)
    const params = {
      id: this.item
    }
    orderInfo(this.item, params).then(res => {
      console.log(res)
      this.data = res.data
      this.length = res.data.orderItemList.length
      console.log(this.data.orderItemList.length)
    }).catch(err => {
      console.log(err)
    })
  }
}
</script>
<style lang="less" scoped>
.shop_detail {
  width: 100%;
  padding: 24px 0 10px;
  overflow: hidden;
  position: relative;
}
.shop_detail .detail {
  float: left;
}
.shop_detail .detail .image {
    position: relative;
}
.shop_detail .detail .image div {
  margin-right: 42px;
  float: left;
  width: 140px;
  height: 140px;
  img{
      width: 100%;
      height: 100%;
  }
}
// .shop_detail .detail .image div {
//   width: 100%;
//   height: 40px;
//   line-height: 40px;
//   text-align: center;
//   font-size: 24px;
//   color: rgba(255, 255, 255, 1);
//   background: rgba(180, 39, 45, 1);
//   position: absolute;
//   left: 0;
//   bottom: 0;
// }
.shop_detail .detail .right {
  float: left;
  width: 390px;
}
.shop_detail .detail .right .box .text_1 {
  color: #333;
  font-size: 28px;
  line-height: 36px;
  padding: 8px 0 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  .abroad,
  .autark {
    float: left;
    width: 76px;
    height: 38px;
    line-height: 34px;
    text-align: center;
    font-size: 24px;
    border-radius: 6px;
    font-weight: 400;
    margin-right: 6px;
  }
}
.shop_detail .detail .right .box .text_2 {
  color: #666;
  font-size: 22px;
  line-height: 26px;
}
.rietagdilht{
    position: absolute;
    right: 60px;
    top: 100px;
}
// .shop_detailTwo {
//   width: 100%;
//   padding: 24px 0 10px;
//   overflow: hidden;
//   position: relative;
// }
.detailTwo {
  float: left;
}
.detailTwo .imageTwo {
  float: left;
  width: 140px;
  height: 140px;
  margin-right: 42px;
  position: relative;
}
.detailTwo .imageTwo.active {
  margin-right: 14px;
}
.detailTwo .imageTwo img {
  float: left;
  width: 140px;
  height: 140px;
}
.detailTwo .imageTwo div {
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 24px;
  color: rgba(255, 255, 255, 1);
  background: rgba(180, 39, 45, 1);
  position: absolute;
  left: 0;
  bottom: 0;
}
.detailTwo .rightTwo {
  float: left;
  width: 390px;
}
.detailTwo .rightTwo .boxTwo .text_1Two {
  color: #333;
  font-size: 28px;
  line-height: 36px;
  padding: 8px 0 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  .abroad,
  .autark {
    float: left;
    width: 76px;
    height: 38px;
    line-height: 34px;
    text-align: center;
    font-size: 24px;
    border-radius: 6px;
    font-weight: 400;
    margin-right: 6px;
  }
}
.detailTwo .rightTwo .box .text_2Two {
  color: #666;
  font-size: 22px;
  line-height: 26px;
}
</style>
